
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title" style="text-transform: capitalize;" v-if="!!id">Sửa Gói Dịch Vụ Mẫu</h3>
        <h3 class="box-title" style="text-transform: capitalize;" v-else>Tạo Mới Gói Dịch Vụ Mẫu</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-xs-12">
            <div class="section-header">
              <i class="fa fa-info"></i>
              <strong>Thông Tin Gói</strong>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{$t('service.package.pkg_name')}}</label>
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('service.package.pkg_name')"
                  v-model="pkg_tmpl.pkg_name"
                />
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{$t('service.package.pkg_type')}}</label>
                <select v-model="pkg_tmpl.pkg_type" class="form-control">
                  <option
                    v-for="(pkg_type, index) in new_package_types"
                    v-bind:value="pkg_type.id"
                    :key="index"
                  >{{ $t(pkg_type.text) }}</option>
                </select>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{$t('service.package.payment_duration_factor')}}</label>
                <b-form-select
                  :options="paymentDurationFactor"
                  v-model="pkg_tmpl.payment_duration_factor"
                  @change="onChangePayment"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="section-header">
              <i class="fa fa-home"></i>
              <strong>Loại Căn Hộ Hướng Tới</strong>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="col-xs-4">
              <div class="form-group">
                <label>{{$t('service.package.pkg_apt_bedrooms')}}</label>
                <input
                  type="number"
                  min="1"
                  class="form-control"
                  :placeholder="$t('service.package.pkg_apt_bedrooms')"
                  v-model="pkg_tmpl.pkg_apt_bedrooms"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="section-header">
              <i class="fa fa-dollar"></i>
              <strong>Thông Tin Dịch Vụ Đi Kèm</strong>
            </div>
          </div>
          <div class="col-xs-12" style="margin-bottom: 20px;">
            <div class="col-xs-12">
              <div class="box box-warning box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Dịch Vụ Không Cố Định</h3>

                  <div class="box-tools pull-right">
                    <button type="button" class="btn btn-box-tool" data-widget="collapse">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <!-- /.box-tools -->
                </div>
                <!-- /.box-header -->
                <div class="box-body" style>
                  <div v-if="pkg_tmpl.package_oncetime_elements.length == 0">Chưa Có Dịch Vụ Nào</div>
                  <div v-else class="service-container">
                    <div class="col-xs-12">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>{{$t('common.nonumber')}}</th>
                            <th>{{$t('apartmentbookings.extraService.service')}}</th>
                            <th
                              class="text-center"
                            >{{$t('apartmentbookings.extraService.quantity')}}</th>
                            <th
                              class="text-right"
                            >{{$t('apartmentbookings.extraService.unit_price')}}</th>
                            <th class="text-right">{{$t('apartmentbookings.extraService.price')}}</th>
                            <th class="text-right">{{$t('apartmentbookings.extraService.vat')}}</th>
                            <th class="text-right">{{$t('apartmentbookings.extraService.tax')}}</th>
                            <th class="text-right">{{$t('apartmentbookings.extraService.total')}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in pkg_tmpl.package_oncetime_elements"
                            :key="index"
                          >
                            <td>{{index + 1}}</td>
                            <td>{{item.name}}</td>
                            <td class="text-center">
                              <input
                                type="number"
                                min="0"
                                class="form-control"
                                v-model="item.quantity"
                                @change="onChangeQuantity(item)"
                              />
                            </td>
                            <td class="text-right">
                              <span class="badge bg-green">{{formatNumber(item.price)}}</span>
                            </td>
                            <td class="text-right">
                              <span class="badge bg-green">{{formatNumber(item.t_price)}}</span>
                            </td>
                            <td class="text-right">
                              <span class="badge bg-blue">{{item.vat}}</span>
                            </td>
                            <td class="text-right">
                              <span class="badge bg-blue">{{item.tax}}</span>
                            </td>
                            <td class="text-right">
                              <span class="badge bg-info">{{formatNumber(item.price_with_tax)}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-primary pull-right"
                      @click="onOpenAddOnceTimeService"
                    >Sửa</button>
                  </div>
                </div>
                <!-- /.box-body -->
              </div>
            </div>
            <div class="col-xs-12">
              <div class="box box-success box-solid">
                <div class="box-header with-border">
                  <h3 class="box-title">Dịch Vụ Cố Định</h3>

                  <div class="box-tools pull-right">
                    <button type="button" class="btn btn-box-tool" data-widget="collapse">
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <!-- /.box-tools -->
                </div>
                <!-- /.box-header -->
                <div class="box-body" style>
                  <div v-if="pkg_tmpl.package_elements.length == 0">Chưa Có Dịch Vụ Nào</div>
                  <div v-else class="service-container">
                    <div class="col-xs-12">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>{{$t('common.nonumber')}}</th>
                            <th>{{$t('apartmentbookings.extraService.service')}}</th>
                            <th
                              class="text-right"
                            >{{$t('apartmentbookings.extraService.unit_price')}}</th>
                            <th class="text-right">{{$t('apartmentbookings.extraService.vat')}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in pkg_tmpl.package_elements" :key="index">
                            <td>{{index + 1}}</td>
                            <td>{{item.name}}</td>
                            <td class="text-right">
                              <span class="badge bg-green">{{formatNumber(item.price)}}</span>
                            </td>
                            <td class="text-right">
                              <span class="badge bg-blue">{{item.vat}}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-primary pull-right"
                      @click="onOpenAddMonthlyService"
                    >Sửa</button>
                  </div>
                </div>
                <!-- /.box-body -->
              </div>
              <small
                class="form-text text-muted"
                style="color: red;"
              >(*) Vui lòng chọn một dịch vụ thuê phòng cho gói.</small>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="col-xs-6">
              <p class="lead">Ghi Chú (không bắt buộc)</p>
              <textarea class="form-control" rows="5" v-model="pkg_tmpl.pkg_other_details"></textarea>
            </div>
            <div class="col-xs-6" v-if="pkg_tmpl.payment_duration_factor !=3">
              <p class="lead">Chi Tiết Phí Cố Định Một {{payment_type}}</p>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <th style="width:50%">Tổng Phí Chưa Thuế:</th>
                      <td>
                        <span class="badge bg-green">{{price_details.sub_price}}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>Thuế:</th>
                      <td>
                        <span class="badge bg-green">{{price_details.vat}}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>Tổng Cộng:</th>
                      <td>
                        <span class="badge bg-green">{{price_details.total}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-xs-6"></div>
            <div class="col-xs-6">
              <p class="lead">Chi Tiết Phí Cố Định Hàng Ngày</p>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <th style="width:50%">Tổng Phí Chưa Thuế:</th>
                      <td>
                        <span class="badge bg-green">{{price_details_by_day.sub_price}}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>Thuế:</th>
                      <td>
                        <span class="badge bg-green">{{price_details_by_day.vat}}</span>
                      </td>
                    </tr>
                    <tr>
                      <th>Tổng Cộng:</th>
                      <td>
                        <span class="badge bg-green">{{price_details_by_day.total}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          style="background-color: #f29911;border-color: #f29911; color: #fff"
          type="button"
          class="btn btn-default pull-left"
          @click="onCancel"
        >
          <i class="fa fa-mail-reply"></i>
          {{$t('common.back')}}
        </button>
        <button
          type="button"
          class="btn btn-primary pull-right"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <button
          type="button"
          class="btn btn-primary pull-right"
          v-else
          @click="onAdd"
        >{{$t('common.add')}}</button>
        <!-- <button
          type="button"
          class="btn btn-warning pull-right"
          style="margin-right: 10px;"
          @click="onReset"
        >Làm Mới</button>-->
      </div>
    </div>
    <!-- Modal Services -->
    <div class="modal fade" :ref="`modal-services`">
      <div class="modal-dialog modal-lg">
        <PackageServicesListView
          :feeGroup="1"
          :selectedServices="pkg_tmpl.package_elements"
          @package-services-save="onPakageServicesSave"
        />
      </div>
    </div>
    <!-- Modal Once Time Services -->
    <div class="modal fade" :ref="`modal-oncetime-services`">
      <div class="modal-dialog modal-lg">
        <PackageOnceTimeServicesListView
          :feeGroup="2"
          :selectedServices="pkg_tmpl.package_oncetime_elements"
          @package-services-save="onPakageServicesSave"
        />
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import RegisterVehicleInputView from './RegisterVehicleInputView'
// import Confirm from "@/components/Confirm.vue"
// import moment from "moment"
import LTECoreAlert from "@/components/LTESnackBar.vue";
import PackageServicesListView from "./PackageServicesListView.vue";
import PackageOnceTimeServicesListView from "./PackageOnceTimeServicesListView.vue";
import utils from '@/lib/utils';
import constants from "@/lib/constantsData";

export default {
  name: "PackageTemplateInputView",
  data() {
    return {
      id: 0,
      pkg_tmpl: {
        pkg_name: null,
        pkg_type: 4,
        pkg_apt_bedrooms: 1,
        pkg_other_details: null,
        package_elements: [],
        package_oncetime_elements: [],
        payment_duration_factor: 1
      },
      price_details: {
        sub_price: 0,
        vat: 0,
        total: 0
      },
      price_details_by_day: {
        sub_price: 0,
        vat: 0,
        total: 0
      },
      paymentDurationFactor: constants.paymentDurationFactor,
      payment_type: null,
      new_package_types: constants.packageTypeText
    };
  },
  watch: {
    package_template_data: function() {
      this.pkg_tmpl.pkg_name = this.package_template_data.pkg_name;
      this.pkg_tmpl.pkg_type = this.package_template_data.pkg_type;
      this.pkg_tmpl.pkg_other_details = this.package_template_data.pkg_other_details;
      this.pkg_tmpl.pkg_apt_bedrooms = this.package_template_data.pkg_apt_bedrooms;
      this.pkg_tmpl.payment_duration_factor = this.package_template_data.payment_duration_factor;
      let package_elements = [];
      let package_oncetime_elements = [];
      this.package_template_data.package_elements.forEach(v => {
        let details = v.service_details;
        let item = {
          service: v.service,
          name: details.name,
          price: details.price,
          vat: details.vat,
          feegroup: details.feegroup,
          service_type: details.service_type,
          quantity: v.quantity
        };
        this.getItemTax(item);
        if (details.feegroup === 1) {
          package_elements.push(item);
        } else {
          package_oncetime_elements.push(item);
        }
      });
      this.pkg_tmpl.package_elements = package_elements;
      this.pkg_tmpl.package_oncetime_elements = package_oncetime_elements;
      this.calculatePrice();
    }
  },
  computed: {
    ...mapGetters("packageModule", {
      package_template_data: "PACKAGE_TEMPLATE_DATA"
    }),
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    ...mapActions("packageModule", [
      "ADD_PACKAGE_TEMPLATE",
      "UPDATE_PACKAGE_TEMPLATE",
      "GET_PACKAGE_TEMPLATE_DETAIL",
    ]),
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST"
    ]),
    getItemTax: function(item) {
      item["tax"] = Math.round(
        (item["quantity"] * item["price"] * item["vat"]) / 100
      );
      item["t_price"] = Math.round(item["quantity"] * item["price"]);
      item["price_with_tax"] = item["tax"] + item["t_price"];
    },
    onChangeQuantity: function(item) {
      this.getItemTax(item);
    },
    validate: function() {
      let validation = {
        status: false,
        error: ""
      };
      let counter = 0;
      let rental_exist = false;
      let rental_exist_bedrooms = true;
      let rental_exist_name = true;
      this.pkg_tmpl.package_elements.forEach(v => {
        if (v.service_type === 9) {
          rental_exist = true;
        }
        counter += 1;
      });
      if (
        this.pkg_tmpl.pkg_apt_bedrooms === null ||
        this.pkg_tmpl.pkg_apt_bedrooms === "" ||
        this.pkg_tmpl.pkg_apt_bedrooms === "0"
      )
        rental_exist_bedrooms = false;
      if (this.pkg_tmpl.pkg_name == null || this.pkg_tmpl.pkg_name == "")
        rental_exist_name = false;
      if (rental_exist === false) {
        validation.error = "Gói chưa có dịch vụ thuê phòng nào.";
      } else if (counter > 1) {
        validation.error =
          "Hiện tại chỉ được phép chọn một dịch vụ thuê phòng.";
      } else if (rental_exist_bedrooms === false) {
        validation.error = "Số phòng ngủ không được để trống.";
      } else if (rental_exist_name === false) {
        validation.error = "Tên gói dịch vụ không được để trống.";
      }
      // validate quantity
      else if (
        this.pkg_tmpl.package_oncetime_elements.filter(
          ele => ele.quantity === null || ele.quantity <= 0
        ).length > 0
      ) {
        validation.error =
          "Số lượng sử dụng dịch vụ không cố định phải lớn hơn 0.";
      } else {
        validation.status = true;
      }
      return validation;
    },
    onSelectDuration: function(duration) {
      this.pkg_tmpl.pk_duration = duration.id;
    },
    formatNumber: function(n) {
      return utils.formatNumber(n);
    },
    calculatePrice: function() {
      let sub_price = 0;
      let vat = 0;
      let sub_price_by_day = 0;
      let vat_by_day = 0;
      this.pkg_tmpl.package_elements.forEach(v => {
        sub_price += v.price;
        vat += Math.round((v.vat * v.price) / 100);
        let tmp_sub_price_by_day =
          this.pkg_tmpl.payment_duration_factor == 1
            ? utils.makeRoundNumber(v.price / 30)
            : this.pkg_tmpl.payment_duration_factor == 2
            ? utils.makeRoundNumber(v.price / 7)
            : utils.makeRoundNumber(v.price / 1);
        sub_price_by_day += tmp_sub_price_by_day;
        vat_by_day += Math.round((v.vat * tmp_sub_price_by_day) / 100);
      });
      this.price_details.sub_price = this.formatNumber(sub_price);
      this.price_details.vat = this.formatNumber(vat);
      this.price_details.total = this.formatNumber(sub_price + vat);

      this.price_details_by_day.sub_price = this.formatNumber(sub_price_by_day);
      this.price_details_by_day.vat = this.formatNumber(vat_by_day);
      this.price_details_by_day.total = this.formatNumber(
        sub_price_by_day + vat_by_day
      );
    },
    onSave: function() {
      let validation = this.validate();
      if (validation.status === false) {
        this.ON_SHOW_TOAST({
          message: validation.error,
          styleType: "danger"
        });
        return;
      }
      const savePackage = {
        pkg_name: this.pkg_tmpl.pkg_name,
        pkg_type: this.pkg_tmpl.pkg_type,
        pkg_other_details: this.pkg_tmpl.pkg_other_details,
        package_elements: this.pkg_tmpl.package_elements.concat(
          this.pkg_tmpl.package_oncetime_elements
        ),
        pkg_apt_bedrooms: this.pkg_tmpl.pkg_apt_bedrooms,
        payment_duration_factor: this.pkg_tmpl.payment_duration_factor
      };
      this.UPDATE_PACKAGE_TEMPLATE({ id: this.id, data: savePackage }).then(
        function(res) {
          this.SUCCESS_TOAST();
          this.$router.push({
            name: "PackageList"
          });
        }.bind(this)
      );
    },
    onAdd: function() {
      let validation = this.validate();
      if (validation.status === false) {
        this.ON_SHOW_TOAST({
          message: validation.error,
          styleType: "danger"
        });
        return;
      }
      const savePackage = {
        pkg_name: this.pkg_tmpl.pkg_name,
        pkg_type: this.pkg_tmpl.pkg_type,
        pkg_other_details: this.pkg_tmpl.pkg_other_details,
        package_elements: this.pkg_tmpl.package_elements.concat(
          this.pkg_tmpl.package_oncetime_elements
        ),
        pkg_apt_bedrooms: this.pkg_tmpl.pkg_apt_bedrooms,
        payment_duration_factor: this.pkg_tmpl.payment_duration_factor
      };
      this.ADD_PACKAGE_TEMPLATE({ data: savePackage }).then(
        function(res) {
          this.SUCCESS_TOAST();
          this.$router.push({
            name: "PackageList"
          });
        }.bind(this)
      );
    },
    getPackageDetails: function() {
      if (parseInt(this.id) !== 0) {
        this.GET_PACKAGE_TEMPLATE_DETAIL({ id: this.id });
      }
    },
    onCancel: function() {
      this.$router.push({
        name: "PackageList"
      });
    },
    onToggleServiceList: function(action = "show") {
      $(this.$refs[`modal-services`]).modal(action);
    },
    onToggleOnceTimeServiceList: function(action = "show") {
      $(this.$refs[`modal-oncetime-services`]).modal(action);
    },
    onOpenAddMonthlyService: function() {
      this.onToggleServiceList();
    },
    onOpenAddOnceTimeService: function() {
      //alert("Chức năng chưa support giai đoạn này, vui lòng liên hệ quản trị của bạn để biết thêm thông tin.")
      this.onToggleOnceTimeServiceList();
    },
    onPakageServicesSave: function(feegroup, elements) {
      let package_elements_data = [];
      elements.forEach(v => {
        let item = {
          service: v.id,
          name: v.name,
          price: v.price,
          vat: v.vat,
          feegroup: v.feegroup,
          service_type: v.service_type,
          quantity: 1
        };
        let old_package_elements = this.pkg_tmpl.package_oncetime_elements.filter(
          ele => ele.service == item.service
        );
        if (old_package_elements.length > 0) {
          item.quantity = old_package_elements[0].quantity;
        }
        this.getItemTax(item);
        package_elements_data.push(item);
      });
      if (feegroup === 1) {
        this.pkg_tmpl.package_elements = package_elements_data;
        this.calculatePrice();
        this.onToggleServiceList("hide");
      } else {
        this.pkg_tmpl.package_oncetime_elements = package_elements_data;
        this.onToggleOnceTimeServiceList("hide");
      }
    },
    onReset: function() {
      this.getPackageDetails();
    },
    onChangePayment: function(val) {
      if (val == 1) {
        this.payment_type = constants.paymentDurationFactor[0].text;
      } else if (val == 2) {
        this.payment_type = constants.paymentDurationFactor[1].text;
      } else {
        this.payment_type = constants.paymentDurationFactor[2].text;
      }
      this.calculatePrice();
    }
  },
  created() {
  },
  mounted() {
    this.id = parseInt(this.$route.params.id);
    this.getPackageDetails();
    this.onChangePayment(this.pkg_tmpl.payment_duration_factor);
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    PackageServicesListView,
    PackageOnceTimeServicesListView
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-container {
  max-height: 400px;
  overflow: auto;
}

.section-header {
  margin: 10px 0 20px 0;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/PackageTemplateInputView.vue